<div class="left">
	<app-logo></app-logo>

	<span>{{vendor}},&nbsp;</span>
	<span class="created-at">Created at {{date|date:"MM/dd/yyyy"}}</span>
</div>

<div class="report-name">
	<ng-content></ng-content>
</div>

<div class="page-number">
	&nbsp;
</div>
